<template>
  <el-card class="box-card">
    <ul v-if="showCheckboxes" class="main-list">
      <div v-for="(element,index) in multitree" :key="index">
        <tree-node :node="element"></tree-node>
      </div>
    </ul>
    <ul v-else class="main-list">
      <div v-for="(element,index) in getVisualsMap" :key="index">
        <tree-node :node="element"></tree-node>
      </div>
    </ul>
  </el-card>
</template>

<script>
import TreeNode from "./TreeNode";
import { mapGetters } from "vuex";
export default {
  components: {
    TreeNode,
  },
  computed: {
    ...mapGetters(["getVisualsMap", "multitree", "showCheckboxes"]),
  },
};
</script>
<style scoped>
.box-card{
  margin-top: 20px;
  margin-left: 5px;
  /* max-height: 85vh; */
  overflow-y: auto;
  scrollbar-color: grey lightgrey;
  scrollbar-width: auto;
}
.box-card::-webkit-scrollbar {
  width: 7px;
}

.box-card::-webkit-scrollbar-track {
  background-color: lightgrey;
}

.box-card::-webkit-scrollbar-thumb {
  background-color: grey;
}
.main-list {
  list-style: none;
  margin-top: 10px;
}
</style>